module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1068.cad28634.png";